import itLocale from 'element-ui/lib/locale/lang/it'
import esLocale from 'element-ui/lib/locale/lang/es'
import deLocale from 'element-ui/lib/locale/lang/de'
import enLocale from 'element-ui/lib/locale/lang/en'

const translations = {
  it_IT: {
    /* Errori */
    err01: 'Dati errati o mancanti (CODE 2)',
    err02: 'Dati errati o mancanti (CODE 1)',
    err03: 'Dati errati o mancanti',
    err04: 'Le Password inserite non corrispondono',
    err05: 'Formato email non valido',
    err06: 'Casella Presa Visione non spuntata',
    err07: 'CAPTCHA non valido o scaduto',
    err08: 'Utente già registrato',
    err09: 'Errore registrazione utente',
    err10: 'Errore autenticazione',
    err11: 'Errore lettura domande di sicurezza',
    err12: 'Errore lettura contatti',
    err13: 'Utente non presente',
    err14: 'Risposta segreta non corretta',
    err15: 'Errore registrazione Password',
    err16: 'Errore invio email',
    err17: 'Errore lettura dati contatto',
    err18: 'Errore lettura documenti',
    err19: 'Errore aggiornamento dati utente',
    err20: 'Vecchia password non corretta',
    err21: 'Errore modifica Password',
    err22: 'Errore registrazione domanda e risposta segreta',
    err23: 'File troppo pesante o formato non valido',
    err24: 'Errore recupero dati utente',
    err25: 'Preview non disponibile',
    err26: 'Errore creazione Preview',
    err27: 'Errore upload documento',
    err28: 'Sessione scaduta',
    err29: 'Nome utente non valido',
    err30: 'Password non valida',
    err31: 'Combinazione peso netto, peso lordo e tara non valida',
    err32: 'Campo "Actual Carrier" obbligatorio',
    err33: 'Password scaduta',
    err34: 'Email non validata',
    /* Messaggi di successo */
    suc01: 'Operazione eseguita con successo. Riceverai a breve una email',
    suc02: 'Messaggio inviato correttamente',
    suc03: 'Operazione eseguita con successo',
    suc04: 'Documento caricato correttamente',
    ACCSTA: {
      label: 'Accesso Stabilimenti',
      icon: 'riv-accessoImp'
    },
    UFFACQ: {
      label: 'Area Acquisti',
      icon: 'riv-uffAcq'
    },
    TRAACQ: {
      label: 'Rottame',
      icon: 'riv-ragno'
    },
    UFFLOG: {
      label: 'Logistica',
      icon: 'riv-trasporti'
    },
    WebBuoniDiCarico: {
      label: 'Buoni di Carico',
      path: '/logistica/buonidicarico/stabilimenti'
    },
    WebGestioneRottame: {
      label: 'Buoni di Scarico',
      path: '/rottame/gestionerottame/conferme'
    },
    WebStoricoRottame: {
      label: 'Storico Viaggi',
      path: '/rottame/storicorottame/buoni'
    },
    WebRichiestaOfferta: {
      label: 'Richieste di Offerta',
      path: '/fornitura/richiestediofferta/offerte'
    },
    SituazioneOrdini: {
      label: 'Situazione Ordini',
      path: '/fornitura/situazioneordini/ordini'
    },
    WebBuoniDiRitiro: {
      label: 'Buoni di Ritiro',
      path: '/fornitura/buonidiritiro/ordini'
    },
    WebTrattativaRottame: {
      label: 'Gestione Trattativa',
      path: '/rottame/gestionetrattativa/trattative'
    },
    WebAnagraficaDip: {
      label: 'Anagrafica Dipendenti',
      path: '/accessostabilimenti/anagraficadipendenti/dipendenti'
    },
    WebDocRichiesti: {
      label: 'Documenti Richiesti',
      path: '/accessostabilimenti/documentirichiesti/elenco'
    },
    WebAssociaDip: {
      label: 'Registrazione Dipendenti',
      path: '/accessostabilimenti/associadipendenti/ordini'
    },
    WebRichiesteQuot: {
      label: 'Richieste di Quotazione',
      path: '/fornitura/richiestediquotazione/quotazioni'
    },
    WebContestazioni: {
      label: 'Contestazioni',
      path: '/accessostabilimenti/contestazioni/elenco'
    },
    ...itLocale,
    el: {
      datepicker: {
        now: 'Ora',
        today: 'Oggi',
        cancel: 'Cancella',
        clear: 'Pulisci',
        confirm: 'OK',
        selectDate: 'Seleziona data',
        selectTime: 'Seleziona ora',
        startDate: 'Data inizio',
        startTime: 'Ora inizio',
        endDate: 'Data fine',
        endTime: 'Ora fine',
        prevYear: 'Previous Year', // to be translated
        nextYear: 'Next Year', // to be translated
        prevMonth: 'Previous Month', // to be translated
        nextMonth: 'Next Month', // to be translated
        year: '',
        month1: 'Gennaio',
        month2: 'Febbraio',
        month3: 'Marzo',
        month4: 'Aprile',
        month5: 'Maggio',
        month6: 'Giugno',
        month7: 'Luglio',
        month8: 'Agosto',
        month9: 'Settembre',
        month10: 'Ottobre',
        month11: 'Novembre',
        month12: 'Dicembre',
        // week: 'settimana',
        weeks: {
          sun: 'Dom',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mer',
          thu: 'Gio',
          fri: 'Ven',
          sat: 'Sab'
        },
        months: {
          jan: 'Gen',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'Mag',
          jun: 'Giu',
          jul: 'Lug',
          aug: 'Ago',
          sep: 'Set',
          oct: 'Ott',
          nov: 'Nov',
          dec: 'Dic'
        }
      },
      table: {
        emptyText: 'Nessun dato',
        confirmFilter: 'Conferma',
        resetFilter: 'Reset',
        clearFilter: 'Tutti',
        sumText: 'Sum' // to be translated
      },
      select: {
        loading: 'Caricamento',
        noMatch: 'Nessuna corrispondenza',
        noData: 'Nessun dato',
        placeholder: 'Seleziona'
      }
    }
  },
  fr_FR: {
    /* Errori */
    err01: 'Données incorrectes ou manquantes (CODE 2)',
    err02: 'Données incorrectes ou manquantes (CODE 1)',
    err03: 'Données incorrectes ou manquantes',
    err04: 'Les mots de passe saisis ne correspondent pas',
    err05: 'Format d\'e-mail non valide',
    err06: 'Case à cocher non cochée',
    err07: 'CAPTCHA invalide ou expiré',
    err08: 'Utilisateur déjà enregistré',
    err09: 'Erreur d\'enregistrement de l\'utilisateur',
    err10: 'Erreur d\'authentification',
    err11: 'Erreur de lecture de la question de sécurité',
    err12: 'Erreur de lecture du contact',
    err13: 'Utilisateur non présent',
    err14: 'Réponse secrète incorrecte',
    err15: 'Erreur d\'enregistrement Mot de passe',
    err16: 'Erreur d\'envoi de l\'e-mail',
    err17: 'Erreur de lecture des données de contact',
    err18: 'Erreur de lecture de documents',
    err19: 'Erreur de mise à jour des données utilisateur',
    err20: 'Ancien mot de passe incorrect',
    err21: 'Erreur de changement de mot de passe',
    err22: 'Erreur d\'enregistrement de la question secrète et de la réponse',
    err23: 'Fichier trop lourd ou format invalide',
    err24: 'Erreur de récupération des données de l\'utilisateur',
    err25: 'Aperçu non disponible',
    err26: 'Erreur lors de la création de l\'aperçu',
    err27: 'Erreur de chargement du document',
    err28: 'Session expirée',
    err29: 'Nom d\'utilisateur non valide',
    err30: 'Mot de passe invalide',
    err31: 'Combinaison du poids net, du poids brut et du poids à vide non valable',
    err32: 'Champ obligatoire "Transporteur réel"',
    err33: 'Mot de passe expiré',
    err34: 'Email non validée',
    /* Messaggi di successo */
    suc01: 'Opération exécutée avec succès. Vous recevrez un courriel sous peu',
    suc02: 'Message envoyé correctement',
    suc03: 'Opération effectuée avec succès',
    suc04: 'Document chargé correctement',
    ACCSTA: {
      label: 'Accès à l\'établissement',
      icon: 'riv-accessoImp'
    },
    UFFACQ: {
      label: 'Fourniture matériel et équipement',
      icon: 'riv-uffAcq'
    },
    TRAACQ: {
      label: 'Transport Ferraille',
      icon: 'riv-ragno'
    },
    UFFLOG: {
      label: 'Logistique',
      icon: 'riv-trasporti'
    },
    WebBuoniDiCarico: {
      label: 'Coupons de Fret',
      path: '/logistica/buonidicarico/stabilimenti'
    },
    WebGestioneRottame: {
      label: 'Gestion de la Ferraille',
      path: '/rottame/gestionerottame/conferme'
    },
    WebStoricoRottame: {
      label: 'Histoire de Voyage',
      path: '/rottame/storicorottame/buoni'
    },
    WebRichiestaOfferta: {
      label: 'Demandes d\'Offre',
      path: '/fornitura/richiestediofferta/offerte'
    },
    SituazioneOrdini: {
      label: 'Situation Commande',
      path: '/fornitura/situazioneordini/ordini'
    },
    WebBuoniDiRitiro: {
      label: 'Coupons de Retraite',
      path: '/fornitura/buonidiritiro/ordini'
    },
    WebTrattativaRottame: {
      label: 'Gestione Trattativa',
      path: '/rottame/gestionetrattativa/trattative'
    },
    WebAnagraficaDip: {
      label: 'Données Employé',
      path: '/accessostabilimenti/anagraficadipendenti/dipendenti'
    },
    WebDocRichiesti: {
      label: 'Documents demandés',
      path: '/accessostabilimenti/documentirichiesti/elenco'
    },
    WebAssociaDip: {
      label: 'Inscription des Employés',
      path: '/accessostabilimenti/associadipendenti/ordini'
    },
    WebRichiesteQuot: {
      label: 'Requêtes de Devis',
      path: '/fornitura/richiestediquotazione/quotazioni'
    }
  },
  es_ES: {
    /* Errori */
    err01: 'Datos incorrectos o ausentes (CODE 2)',
    err02: 'Datos incorrectos o ausentes (CODE 1)',
    err03: 'Datos incorrectos o ausentes',
    err04: 'Las contraseñas introducidas no coinciden',
    err05: 'Formato de correo electrónico no válido',
    err06: 'Casilla de verificación sin marcar',
    err07: 'CAPTCHA inválido o caducado',
    err08: 'Usuario ya registrado',
    err09: 'Error de registro de usuario',
    err10: 'Error de autenticación',
    err11: 'Error de lectura de la pregunta de seguridad',
    err12: 'Error de lectura de los contactos',
    err13: 'Usuario no presente',
    err14: 'Respuesta secreta incorrecta',
    err15: 'Error de registro Contraseña',
    err16: 'Error al enviar correo electrónico',
    err17: 'Error de lectura de los datos de contacto',
    err18: 'Error al leer documentos',
    err19: 'Error de actualización de datos de usuario',
    err20: 'Contraseña antigua incorrecta',
    err21: 'Error de cambio de contraseña',
    err22: 'Error en la grabación de la pregunta y respuesta secretas',
    err23: 'Fichero demasiado pesado o formato no válido',
    err24: 'Error de recuperación de datos del usuario',
    err25: 'Vista previa no disponible',
    err26: 'Error al crear la vista previa',
    err27: 'Error al cargar el documento',
    err28: 'Sesión caducada',
    err29: 'Nombre de usuario no válido',
    err30: 'Contraseña no válida',
    err31: 'Combinación de peso neto, peso bruto y tara no válida',
    err32: 'Campo obligatorio "Transportista real"',
    err33: 'Contraseña caducada',
    err34: 'Correo electrónico no verificado',
    /* Messaggi di successo */
    suc01: 'Operación ejecutada con éxito. En breve recibirá un correo electrónico',
    suc02: 'Mensaje enviado correctamente',
    suc03: 'Operación realizada con éxito',
    suc04: 'Documento cargado correctamente',
    ACCSTA: {
      label: 'Acceso al Establecimiento',
      icon: 'riv-accessoImp'
    },
    UFFACQ: {
      label: 'Suministro Materiales y Equipos',
      icon: 'riv-uffAcq'
    },
    TRAACQ: {
      label: 'Chatarra Transporte',
      icon: 'riv-ragno'
    },
    UFFLOG: {
      label: 'Logistica',
      icon: 'riv-trasporti'
    },
    WebBuoniDiCarico: {
      label: 'Cupones de Carga',
      path: '/logistica/buonidicarico/stabilimenti'
    },
    WebGestioneRottame: {
      label: 'Gestión Chatarra',
      path: '/rottame/gestionerottame/conferme'
    },
    WebStoricoRottame: {
      label: 'Historia de Viajes',
      path: '/rottame/storicorottame/buoni'
    },
    WebRichiestaOfferta: {
      label: 'Peticiones de Oferta (Recambios)',
      path: '/fornitura/richiestediofferta/offerte'
    },
    SituazioneOrdini: {
      label: 'Situación Pedidos',
      path: '/fornitura/situazioneordini/ordini'
    },
    WebBuoniDiRitiro: {
      label: 'Avisos de Retirada',
      path: '/fornitura/buonidiritiro/ordini'
    },
    WebTrattativaRottame: {
      label: 'Gestione Trattativa',
      path: '/rottame/gestionetrattativa/trattative'
    },
    WebAnagraficaDip: {
      label: 'Datos maestros de empleados',
      path: '/accessostabilimenti/anagraficadipendenti/dipendenti'
    },
    WebDocRichiesti: {
      label: 'Documentos requeridos',
      path: '/accessostabilimenti/documentirichiesti/elenco'
    },
    WebAssociaDip: {
      label: 'Registro de Empleados',
      path: '/accessostabilimenti/associadipendenti/ordini'
    },
    WebRichiesteQuot: {
      label: 'Peticiones de Oferta (Servicios)',
      path: '/fornitura/richiestediquotazione/quotazioni'
    },
    ...esLocale,
    el: {
      table: {
        emptyText: 'Ningún dato'
      }
    }
  },
  de_DE: {
    /* Errori */
    err01: 'Falsche oder fehlende Daten (CODE 2)',
    err02: 'Falsche oder fehlende Daten (CODE 1)',
    err03: 'Falsche oder fehlende Daten',
    err04: 'Eingegebene Passwörter stimmen nicht überein',
    err05: 'Ungültiges E-Mail-Format',
    err06: 'Nicht markiertes Kontrollkästchen',
    err07: 'CAPTCHA ungültig oder abgelaufen',
    err08: 'Bereits registrierter Benutzer',
    err09: 'Fehler bei der Benutzerregistrierung',
    err10: 'Authentifizierungsfehler',
    err11: 'Fehler beim Lesen der Sicherheitsfrage',
    err12: 'Kontakt-Lesefehler',
    err13: 'Benutzer nicht anwesend',
    err14: 'Falsche Sicherheitsantwort',
    err15: 'Registrierungsfehler Passwort',
    err16: 'Fehler beim Senden der E-Mail',
    err17: 'Fehler beim Lesen der Kontaktdaten',
    err18: 'Fehler beim Lesen von Dokumenten',
    err19: 'Fehler bei der Aktualisierung der Benutzerdaten',
    err20: 'Altes Passwort falsch',
    err21: 'Fehler bei der Passwortänderung',
    err22: 'Fehler bei der Aufzeichnung der Sicherheitsfragen und Antworten',
    err23: 'Datei zu groß oder ungültiges Format',
    err24: 'Fehler bei der Wiederherstellung von Benutzerdaten',
    err25: 'Vorschau nicht verfügbar',
    err26: 'Fehler beim Erstellen der Vorschau',
    err27: 'Fehler beim Laden des Dokuments',
    err28: 'Abgelaufene Sitzung',
    err29: 'Ungültiger Benutzername',
    err30: 'Ungültiges Passwort',
    err31: 'Kombination aus Netto-, Brutto- und Taragewicht ungültig',
    err32: 'Erforderliches Feld "Actual Carrier"',
    err33: 'Passwort abgelaufen',
    err34: 'E-Mail nicht verifiziert',
    /* Messaggi di successo */
    suc01: 'Auftrag erfolgreich durchgeführt. Sie werden in Kürze eine E-Mail erhalten',
    suc02: 'Nachricht korrekt gesendet',
    suc03: 'Auftrag erfolgreich durchgeführt',
    suc04: 'Dokument korrekt geladen',
    ACCSTA: {
      label: 'Zugang zur Einrichtung',
      icon: 'riv-accessoImp'
    },
    UFFACQ: {
      label: 'Einkaufsbereich',
      icon: 'riv-uffAcq'
    },
    TRAACQ: {
      label: 'Schrott Transport',
      icon: 'riv-ragno'
    },
    UFFLOG: {
      label: 'Logistik',
      icon: 'riv-trasporti'
    },
    WebBuoniDiCarico: {
      label: 'Gutscheine',
      path: '/logistica/buonidicarico/stabilimenti'
    },
    WebGestioneRottame: {
      label: 'Schrottlieferungen',
      path: '/rottame/gestionerottame/conferme'
    },
    WebStoricoRottame: {
      label: 'Verlauf Schrotteingänge',
      path: '/rottame/storicorottame/buoni'
    },
    WebRichiestaOfferta: {
      label: 'Angebotsanfragen',
      path: '/fornitura/richiestediofferta/offerte'
    },
    SituazioneOrdini: {
      label: 'Bestellsituation',
      path: '/fornitura/situazioneordini/ordini'
    },
    WebBuoniDiRitiro: {
      label: 'Abholavis',
      path: '/fornitura/buonidiritiro/ordini'
    },
    WebTrattativaRottame: {
      label: 'Schrottverhandlung',
      path: '/rottame/gestionetrattativa/trattative'
    },
    WebAnagraficaDip: {
      label: 'Mitarbeiterstammdaten',
      path: '/accessostabilimenti/anagraficadipendenti/dipendenti'
    },
    WebDocRichiesti: {
      label: 'Angeforderte Dokumente',
      path: '/accessostabilimenti/documentirichiesti/elenco'
    },
    WebAssociaDip: {
      label: 'Mitarbeiterregistrierung',
      path: '/accessostabilimenti/associadipendenti/ordini'
    },
    WebRichiesteQuot: {
      label: 'Richieste di Quotazione',
      path: '/fornitura/richiestediquotazione/quotazioni'
    },
    ...deLocale,
    el: {
      table: {
        emptyText: 'Keine Daten Vorhanden'
      },
      datepicker: {
        month1: 'Januar',
        month2: 'Februar',
        month3: 'März',
        month4: 'April',
        month5: 'Mai',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'August',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'Dezember',
        weeks: {
          sun: 'Son',
          mon: 'Mon',
          tue: 'Die',
          wed: 'Mit',
          thu: 'Don',
          fri: 'Fre',
          sat: 'Sam'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mär',
          apr: 'Apr',
          may: 'Mai',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Dez'
        }
      }
    }
  },
  en_GB: {
    /* Errori */
    err01: 'Incorrect or missing data (CODE 2)',
    err02: 'Incorrect or missing data (CODE 1)',
    err03: 'Incorrect or missing data',
    err04: 'Passwords entered do not match',
    err05: 'Invalid email format',
    err06: 'Unchecked Checkbox',
    err07: 'CAPTCHA invalid or expired',
    err08: 'User already registered',
    err09: 'User registration error',
    err10: 'Authentication error',
    err11: 'Error reading security question',
    err12: 'Contact reading error',
    err13: 'Username not present',
    err14: 'Incorrect secret answer',
    err15: 'Password Registration Error ',
    err16: 'Error sending email',
    err17: 'Contact data reading error',
    err18: 'Error reading documents',
    err19: 'User data update error',
    err20: 'Incorrect old password',
    err21: 'Password change error',
    err22: 'Error recording secret question and answer',
    err23: 'File too heavy or invalid format',
    err24: 'User data recovery error',
    err25: 'Preview not available',
    err26: 'Error creating Preview',
    err27: 'Error uploading file',
    err28: 'Expired session',
    err29: 'Invalid username',
    err30: 'Invalid password',
    err31: 'Combination net weight, gross weight and tare weight invalid',
    err32: '"Actual Carrier" field mandatory',
    err33: 'Password expired',
    err34: 'Email not verified',
    /* Messaggi di successo */
    suc01: 'Operation performed successfully. You will receive an email shortly',
    suc02: 'Message sent correctly',
    suc03: 'Operation successfully performed',
    suc04: 'Document loaded correctly',
    ACCSTA: {
      label: 'Establishment access',
      icon: 'riv-accessoImp'
    },
    UFFACQ: {
      label: 'Supply of Materials and Equipment',
      icon: 'riv-uffAcq'
    },
    TRAACQ: {
      label: 'Transport Scrap',
      icon: 'riv-ragno'
    },
    UFFLOG: {
      label: 'Logistics',
      icon: 'riv-trasporti'
    },
    WebBuoniDiCarico: {
      label: 'Load Voucher',
      path: '/logistica/buonidicarico/stabilimenti'
    },
    WebGestioneRottame: {
      label: 'Scrap management',
      path: '/rottame/gestionerottame/conferme'
    },
    WebStoricoRottame: {
      label: 'Travel History',
      path: '/rottame/storicorottame/buoni'
    },
    WebRichiestaOfferta: {
      label: 'Offer Requests',
      path: '/fornitura/richiestediofferta/offerte'
    },
    SituazioneOrdini: {
      label: 'Order situation',
      path: '/fornitura/situazioneordini/ordini'
    },
    WebBuoniDiRitiro: {
      label: 'Pick-up voucher',
      path: '/fornitura/buonidiritiro/ordini'
    },
    WebTrattativaRottame: {
      label: 'Gestione Trattativa',
      path: '/rottame/gestionetrattativa/trattative'
    },
    WebAnagraficaDip: {
      label: 'Employee master data',
      path: '/accessostabilimenti/anagraficadipendenti/dipendenti'
    },
    WebDocRichiesti: {
      label: 'Requested documents',
      path: '/accessostabilimenti/documentirichiesti/elenco'
    },
    WebAssociaDip: {
      label: 'Employee Registration',
      path: '/accessostabilimenti/associadipendenti/ordini'
    },
    WebRichiesteQuot: {
      label: 'Richieste di Quotazione',
      path: '/fornitura/richiestediquotazione/quotazioni'
    },
    ...enLocale,
    el: {
      table: {
        emptyText: 'No Data Available'
      },
      datepicker: {
        month1: 'January',
        month2: 'February',
        month3: 'March',
        month4: 'April',
        month5: 'May',
        month6: 'June',
        month7: 'July',
        month8: 'August',
        month9: 'September',
        month10: 'October',
        month11: 'November',
        month12: 'December',
        weeks: {
          sun: 'Sun',
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'May',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Oct',
          nov: 'Nov',
          dec: 'Dec'
        }
      }
    }
  }
}

export default translations



// WEBPACK FOOTER //
// ./src/assets/Traduzioni.js